"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOKEN_REFRESH_SERVER_BUFFER_MS = exports.TOKEN_REFRESH_BUFFER_MS = exports.IDENTITY_BASE_PATH = void 0;
exports.IDENTITY_BASE_PATH = '/identity';
/**
 * Note - this has to be shared between the frontend and the backend.
 * If the frontend tries to refresh w a longer buffer than the backend, it won't actually get a refresh token back.
 */
exports.TOKEN_REFRESH_BUFFER_MS = 5 * 60 * 1000;
exports.TOKEN_REFRESH_SERVER_BUFFER_MS = exports.TOKEN_REFRESH_BUFFER_MS + 1000;
